import { render, staticRenderFns } from "./QLServiziFerrara.vue?vue&type=template&id=202d05a6&scoped=true&"
import script from "./QLServiziFerrara.vue?vue&type=script&lang=js&"
export * from "./QLServiziFerrara.vue?vue&type=script&lang=js&"
import style0 from "./QLServiziFerrara.vue?vue&type=style&index=0&id=202d05a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d05a6",
  null
  
)

export default component.exports